<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue'

const emit = defineEmits(['resized'])
const itemRef = ref()

const resizeObserver = new ResizeObserver(entries => {
  // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
  emit('resized', itemRef.value)
})
onMounted(() => {
  resizeObserver.observe(itemRef.value)
})
onBeforeUnmount(() => {
  resizeObserver.disconnect()
})
</script>

<template>
  <div
    ref="itemRef"
    class="role_resizeobserve"
  >
    <slot />
  </div>
</template>
